// API-4001 POST /api/inquiry request
export type InquiryApiRequest = {
    company: string;
    division: string;
    name: string;
    kana: string;
    mail: string;
    phone: string;
    reason_id?: number;
    reason_comment: string;
    inquiry_estimate_id?: string;
    comment?: string;
    device_list_request?: number;
    inquire_type?: Array<number>;
};

// API-4001 POST /api/inquiry response
export type InquiryApiResponse = {
    status: boolean;
    message: string;
    receipt_number: string;
};

// API ERROR
export const INQUIRY_API_ERRORS = {
    REQUEST_ERROR_4001: 'REQUEST_ERROR(4001)',
    REQUEST_ERROR_4001_STATUS_CODE: 'REQUEST_ERROR(4001)_%1',
    REQUEST_ERROR_4002: 'REQUEST_ERROR(4002)',
    REQUEST_ERROR_4002_STATUS_CODE: 'REQUEST_ERROR(4002)_%1',
};
